 
import "./MainNavbar.scss";

import React, {
  useCallback,
  useContext
} from "react";

import MenuIcon from "@mui/icons-material/Menu";
import SearchIcon from "@mui/icons-material/Search";
import {
  Box,
  Button,
  Menu,
  MenuItem
} from "@mui/material";
import IconButton from "@mui/material/IconButton";

import { Media } from "../../shared/contexts/media/MediaContext";
import { UiStateContext } from "../../shared/contexts/ui-state/UiStateContext";
import useFeatureToggle from "../../shared/hooks/use-feature-toggle/useFeatureToggle";
import {
  FeatureToggle,
  LoginDropdownItems,
  MainNavbarLinks
} from "../../shared/models/app-data-model";
import { Dropdown } from "./dropdown/Dropdown";
import { Person } from '@mui/icons-material';

interface MainNavbarProps {
  mainNavbarLinks: MainNavbarLinks[];
  featureToggles: FeatureToggle[];
  loginDropdownItems: LoginDropdownItems;
}
export const MainNavbar: React.FC<MainNavbarProps> = ({ mainNavbarLinks, featureToggles, loginDropdownItems }: MainNavbarProps) => {
  const showSearch = useFeatureToggle('search-with-kendra', featureToggles);
  const uiStateContext = useContext(UiStateContext);
  const navbarLinks = mainNavbarLinks?.map((mainNavbarLink, index) => {
    return (
      <MenuItem
        tabIndex={0}
        key={index}
        sx={{
          my: 2
        }}
        component='a'
        href={mainNavbarLink.global_field.reference[0]?.url || '/'}
      >
        {mainNavbarLink.global_field.title}
      </MenuItem>
    );
  });
  const loginItemLinks = loginDropdownItems.login_item?.map((loginItem, index) => {
    return (
      <MenuItem
        key={index}
        sx={{
          my: 2
        }}
        component='a'
        href={loginItem.href}
      >
        {loginItem.title}
      </MenuItem>
    );
  });
  const menuIcon: React.ReactElement = (
    <IconButton size='large' aria-controls='menu-appbar' aria-haspopup='true' color='inherit'>
      <MenuIcon />
    </IconButton>
  );
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const loginMenu: React.ReactElement = (
      <Menu id="login-menu" 
        aria-labelledby='login-button' 
        anchorEl={anchorEl} open={open}
        onClose={handleClose}>
          {loginItemLinks}
      </Menu>
  );

  const handleSearchClick = useCallback((): void => {
    uiStateContext.setSearchOpen?.(true);
  }, [uiStateContext]);
  return (
    <Box className='main-navbar'>

      <Media lessThan='md' className="top-nav-wrapper-mobile">
        {showSearch && <IconButton size='large' aria-label="search" color='inherit' onClick={handleSearchClick}>
          <SearchIcon data-testid="search-icon" />
        </IconButton>
        }
        <Dropdown aria-label="Navigation menu dropdown button" icon={menuIcon} dropdownOptions={navbarLinks} tooltipText='Navigation menu' />
        {<Button 
            size='small'
            variant="outlined"
            aria-label='Login button'
            color='inherit'
            id='login-button'
            data-testid='login-button'
            aria-controls={open ? 'login-menu' : undefined}
            aria-haspopup='true'
            aria-expanded={open ? 'true' : undefined}
            onClick={handleClick}>
              Login
          </Button>}
        {loginMenu}
      </Media>
      <Media className='top-nav-wrapper' greaterThanOrEqual='md'>
        <Box className='site-top-navigation-left'>{navbarLinks}</Box>        
          <Box className='site-top-navigation-right'>
            {showSearch && (
              <IconButton size='large' aria-label="search" color='inherit' data-testid="search-now" title="Search now" onClick={handleSearchClick}>
                <SearchIcon data-testid="search-icon" />
              </IconButton>
            )}
            {<Button 
            variant='outlined' 
            color='inherit' 
            id='login-button' 
            data-testid='login-button-test'
            aria-controls={open ? 'login-menu' : undefined} 
            aria-haspopup='true' 
            aria-expanded={open ? 'true' : undefined} 
            onClick={handleClick} 
            startIcon={<Person />}>Login</Button>}
            {loginMenu}
          </Box>
        
      </Media>
    </Box>
  );
};